// Account
export const GET_ACCOUNT = 'GET_ACCOUNT';
export const UPDATE_ACCOUNT = 'UPDATE_ACCOUNT';
export const RESET_ACCOUNT = 'RESET_ACCOUNT';
export const UPDATE_IS_SYNC_PROGRESS = 'UPDATE_IS_SYNC_PROGRESS';
export const AIRBNB_SHOULD_SYNC = 'AIRBNB_SHOULD_SYNC';

// Auth
export const CHECK_AUTHENTICATION = 'CHECK_AUTHENTICATION';
export const LOGOUT = 'LOGOUT';
export const LOGIN = 'LOGIN';

// Users
export const GET_USERS = 'GET_USERS';

//Booking
export const GET_BOOKING = 'GET_BOOKING';
export const UPDATE_BOOKING = 'UPDATE_BOOKING';

// Billing
export const GET_BILLING = 'GET_BILLING';
export const UPDATE_BILLING = 'UPDATE_BILLING';

//Change Lang
export const CHANGE_LANG = 'CHANGE_LANG';
export const CHANGE_PLAN = 'CHANGE_PLAN';



// WEBPACK FOOTER //
// ./src/app/store/mutation-types.js